import { styled } from "@mui/material/styles";
import {StyleguideSavioFonts} from "../../../../configuration/themeSettings"

export const Root = styled("div", { label: "AppContext-root" })(
  ({ theme }) => ({
    display: "flex",
    fontSize: "1.25rem",
    fontWeight: StyleguideSavioFonts.medium,
    marginLeft: 20,
    minWidth: 160,
  })
);
